import { API_URL_SUMMARY_LAMBDAS } from '../config/Environment';
import { type AuthStore, getOrCreateAuthStore } from '../stores/authStore'; // oxlint-disable-line import/no-cycle -- Pre-existing dependency cycle, grandfathered during the oxlint migration.
import {
	createAxiosInstance,
	getErrorHandler,
	getSuccessHandler,
	type WithAxiosServer,
	type SessionsApi,
} from './createAxiosInstance'; // oxlint-disable-line import/no-cycle -- Pre-existing dependency cycle, grandfathered during the oxlint migration.

import type { AxiosInstance } from 'axios';

class ApiSessionsServer implements WithAxiosServer, SessionsApi {
	server: AxiosInstance;

	authStore: AuthStore;

	constructor() {
		this.server = createAxiosInstance(API_URL_SUMMARY_LAMBDAS);
		this.authStore = getOrCreateAuthStore();
	}

	getToken = (): typeof this.authStore.getToken => {
		return this.authStore.getToken;
	};

	refreshSession = async (): ReturnType<typeof this.authStore.refreshToken> => {
		return this.authStore.refreshToken();
	};

	resetSession = async (): ReturnType<typeof this.authStore.logoutAndRedirectToLoginPage> =>
		this.authStore.logoutAndRedirectToLoginPage();

	changePassword = async (accessToken: string, oldPassword: string, newPassword: string) => {
		return this.server.patch(
			'changePassword',
			{ accessToken, oldPassword, newPassword },
			{
				headers: { token: accessToken, 'content-type': 'application/json' },
			},
		);
	};
}

let maybeApiSessionsServer: ApiSessionsServer | null = null;

function createApiSessionsServer(): ApiSessionsServer {
	const apiSessionsServer = new ApiSessionsServer();

	apiSessionsServer.server.interceptors.response.use(
		getSuccessHandler(),
		getErrorHandler(apiSessionsServer.server, apiSessionsServer),
	);

	return apiSessionsServer;
}

export function getOrCreateApiSessionsServer(): ApiSessionsServer {
	if (maybeApiSessionsServer === null) {
		maybeApiSessionsServer = createApiSessionsServer();
	}
	return maybeApiSessionsServer;
}
